const PartNumber = {
  normalize(value) {
    if (!value) {
      return ''
    }

    if ('string' !== typeof value) {
      value = "" + value
    }

    if (value.match(/^[0-9]{4}-[0-9]{5}$/)) {
      value = value.substring(5);
    }

    if (value.match(/^[0-9]+-[0-9]+/)) {
      value = value.replace(/^[0-9]+-([0-9]+)$/, '$1');
    }

    return value
  }
}

export {
  PartNumber
}
